import { Box, Text, SystemStyleObject } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import React, { FC, useEffect, useRef, useState } from 'react';

const NumbersWrapper = styled(Box)`
  position: relative;
  overflow: hidden;
`;

const Numbers = styled(Box)<{ digit: number; prevDigit: number; offset: number; fontSize: string }>`
  position: absolute;
  display: flex;
  flex-direction: column;
  animation: ${(props): string => `number${props.digit}${props.offset}prev${props.prevDigit}`} 1.5s forwards;

  span {
    text-align: center;
    font-size: ${(props): string => props.fontSize};
  }
  @keyframes ${(props): string => `number${props.digit}${props.offset}prev${props.prevDigit}`} {
    from {
      transform: translateY(${(props): number => (props.prevDigit + 1) * props.offset * -1}px);
    }
    to {
      transform: translateY(${(props): number => (props.digit + 1) * props.offset * -1}px);
    }
  }
`;
interface Props {
  digit: number;
  fontSize: string;
  sx?: SystemStyleObject;
}

const AnimatedDigit: FC<Props> = ({ digit, fontSize, sx }) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const animRef = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState(0);
  const [prev, _setPrev] = useState(0);
  const digitRef = useRef(digit);
  const prevRef = useRef(prev);

  const setPrev = (data: number): void => {
    prevRef.current = data;
    _setPrev(data);
  };

  useEffect(() => {
    if (ref.current) {
      setOffset(ref.current.offsetHeight);
    }
  }, []);

  useEffect(() => {
    digitRef.current = digit;
  }, [digit]);

  const handleListener = (): void => {
    setPrev(digitRef.current);
  };

  useEffect(() => {
    if (!animRef.current && !ref.current) {
      return;
    }

    document.addEventListener('animationend', handleListener, false);

    return (): void => document.removeEventListener('animationend', handleListener, false);
  }, []);

  return (
    <NumbersWrapper>
      <Text ref={ref} color="transparent" fontSize={fontSize} fontFamily="heading" fontWeight="normal">
        0
      </Text>
      <Numbers ref={animRef} digit={digit} offset={offset} fontSize={fontSize} prevDigit={prev} sx={sx}>
        {/*
//@ts-ignore */}
        {[...Array(10).keys()].map(k => (
          <span key={k}>{k}</span>
        ))}
      </Numbers>
    </NumbersWrapper>
  );
};

export default AnimatedDigit;
